module.exports = __webpack_public_path__ + "img/4.aec6cffb.jpg";